import { CanvasSharedData } from '../components/ImageCanvasIFrame/ImageCanvasIFrame';
import { BannerId, CreativeId } from '../typings/banners';
import { EditorPlaceId } from '../typings/common';
import { CreativeState } from '../typings/creative';
import { BannerImageForEdit } from '../typings/domain';

export const OPEN_CREATIVE_CONSTRUCTOR = 'OPEN_CREATIVE_CONSTRUCTOR';
export type OPEN_CREATIVE_CONSTRUCTOR = typeof OPEN_CREATIVE_CONSTRUCTOR;
export interface OpenCreativeConstructor {
    type: OPEN_CREATIVE_CONSTRUCTOR;
    bannerId: BannerId;
    sharedData?: CanvasSharedData;
}
export function openCreativeConstructor(
    bannerId: BannerId,
    sharedData?: CanvasSharedData
): OpenCreativeConstructor {
    return {
        type: OPEN_CREATIVE_CONSTRUCTOR,
        bannerId,
        sharedData
    };
}

export const OPEN_CREATIVE_CONSTRUCTOR_PRESETS =
    'OPEN_CREATIVE_CONSTRUCTOR_PRESETS';
export type OPEN_CREATIVE_CONSTRUCTOR_PRESETS = typeof OPEN_CREATIVE_CONSTRUCTOR_PRESETS;
export interface OpenCreativeConstructorPresets {
    type: OPEN_CREATIVE_CONSTRUCTOR_PRESETS;
    bannerId: BannerId;
    sharedData?: CanvasSharedData;
}
export function openCreativeConstructorPresets(
    bannerId: BannerId,
    sharedData?: CanvasSharedData
): OpenCreativeConstructorPresets {
    return {
        type: OPEN_CREATIVE_CONSTRUCTOR_PRESETS,
        bannerId,
        sharedData
    };
}

export const OPEN_CREATIVE_HTML5_CONSTRUCTOR =
    'OPEN_CREATIVE_HTML5_CONSTRUCTOR';
export type OPEN_CREATIVE_HTML5_CONSTRUCTOR = typeof OPEN_CREATIVE_HTML5_CONSTRUCTOR;
export interface OpenCreativeHtml5Constructor {
    type: OPEN_CREATIVE_HTML5_CONSTRUCTOR;
    bannerId: BannerId;
    sharedData?: CanvasSharedData;
}
export function openCreativeHtml5Constructor(
    bannerId: BannerId,
    sharedData?: CanvasSharedData
): OpenCreativeHtml5Constructor {
    return {
        type: OPEN_CREATIVE_HTML5_CONSTRUCTOR,
        bannerId,
        sharedData
    };
}

export const OPEN_CREATIVE_IDEAS = 'OPEN_CREATIVE_IDEAS';
export type OPEN_CREATIVE_IDEAS = typeof OPEN_CREATIVE_IDEAS;
export interface OpenCreativeIdeas {
    type: OPEN_CREATIVE_IDEAS;
    bannerId: BannerId;
}
export function openCreativeIdeas(bannerId: BannerId): OpenCreativeIdeas {
    return {
        type: OPEN_CREATIVE_IDEAS,
        bannerId
    };
}

export const OPEN_CREATIVE_HTML5_ADD_CONSTRUCTOR =
    'OPEN_CREATIVE_HTML5_ADD_CONSTRUCTOR';
export type OPEN_CREATIVE_HTML5_ADD_CONSTRUCTOR = typeof OPEN_CREATIVE_HTML5_ADD_CONSTRUCTOR;
export interface OpenCreativeHtml5AddConstructor {
    type: OPEN_CREATIVE_HTML5_ADD_CONSTRUCTOR;
    bannerId: BannerId;
    sharedData?: CanvasSharedData;
}
export function openCreativeHtml5AddConstructor(
    bannerId: BannerId,
    sharedData?: CanvasSharedData
): OpenCreativeHtml5AddConstructor {
    return {
        type: OPEN_CREATIVE_HTML5_ADD_CONSTRUCTOR,
        bannerId,
        sharedData
    };
}

export const UPDATE_BANNER_CREATIVE_ID = 'UPDATE_BANNER_CREATIVE_ID';
export type UPDATE_BANNER_CREATIVE_ID = typeof UPDATE_BANNER_CREATIVE_ID;
export interface UpdateBannerCreativeId {
    type: UPDATE_BANNER_CREATIVE_ID;
    id: EditorPlaceId;
    ids: CreativeId[];
}

export function updateBannerCreativeId(
    id: EditorPlaceId,
    ids: CreativeId[]
): UpdateBannerCreativeId {
    return {
        type: UPDATE_BANNER_CREATIVE_ID,
        id,
        ids
    };
}

export const UPDATE_BANNER_CREATIVE_DATA = 'UPDATE_BANNER_CREATIVE_DATA';
export type UPDATE_BANNER_CREATIVE_DATA = typeof UPDATE_BANNER_CREATIVE_DATA;
export interface UpdateBannerCreativeData {
    type: UPDATE_BANNER_CREATIVE_DATA;
    bannerId: BannerId;
    creative: BannerImageForEdit;
}

export function updateBannerCreativeData(
    bannerId: BannerId,
    creative: BannerImageForEdit
): UpdateBannerCreativeData {
    return {
        type: UPDATE_BANNER_CREATIVE_DATA,
        bannerId,
        creative
    };
}

export const MASS_UPDATE_BANNER_CREATIVE_DATA =
    'MASS_UPDATE_BANNER_CREATIVE_DATA';
export type MASS_UPDATE_BANNER_CREATIVE_DATA = typeof MASS_UPDATE_BANNER_CREATIVE_DATA;
export interface MassUpdateBannerCreativeData {
    type: MASS_UPDATE_BANNER_CREATIVE_DATA;
    bannerId: EditorPlaceId;
    creatives: BannerImageForEdit[];
}

export function massUpdateBannerCreativeData(
    bannerId: EditorPlaceId,
    creatives: BannerImageForEdit[]
): MassUpdateBannerCreativeData {
    return {
        type: MASS_UPDATE_BANNER_CREATIVE_DATA,
        bannerId,
        creatives
    };
}

export const SET_CREATIVE_DATA = 'SET_CREATIVE_DATA';
export type SET_CREATIVE_DATA = typeof SET_CREATIVE_DATA;
export interface SetCreativeData {
    type: SET_CREATIVE_DATA;
    creative: CreativeState;
}
export function setCreativeData(creative: CreativeState): SetCreativeData {
    return {
        type: SET_CREATIVE_DATA,
        creative
    };
}

export const CLOSE_CREATIVE_CONSTRUCTOR = 'CLOSE_CREATIVE_CONSTRUCTOR';
export type CLOSE_CREATIVE_CONSTRUCTOR = typeof CLOSE_CREATIVE_CONSTRUCTOR;
export interface CloseCreativeConstructor {
    type: CLOSE_CREATIVE_CONSTRUCTOR;
    bannerId: BannerId;
}
export function closeCreativeConstructor(
    bannerId: BannerId
): CloseCreativeConstructor {
    return {
        type: CLOSE_CREATIVE_CONSTRUCTOR,
        bannerId
    };
}

export type CreativeConstructorActions =
    | OpenCreativeConstructor
    | OpenCreativeIdeas
    | OpenCreativeConstructorPresets
    | UpdateBannerCreativeId
    | OpenCreativeHtml5Constructor
    | OpenCreativeHtml5AddConstructor
    | UpdateBannerCreativeData
    | CloseCreativeConstructor
    | SetCreativeData
    | MassUpdateBannerCreativeData;
